import React, { Component } from 'react';
import Moment from 'moment/moment';
import Config from '../../Util/config';
import { Container, Row, Col, Popover, PopoverBody } from 'reactstrap';
import HttpUtil from '../../Util/httpUtil';
import '../../_Content/css/header-resultado.css';
import OpcoesDownloadItem from './../Modulo/OpcoesDownloadItem';
import { withRouter } from 'react-router-dom';
import FiltroItensEmDivergencia from './FiltroItensEmDivergencia';
import RemoverResultadoItem from './../Modulo/RemoverResultadoItem';
import ModalConfirmacao from '../Modulo/ModalConfirmacao';
import ModalAlerta from '../Modulo/ModalAlerta';

const idUsuario = localStorage.getItem("CodUsuario");
const isSimulacao = localStorage.getItem('isSimulacao') === 'true';
const isPro = localStorage.getItem('isPro') === 'true';

class HeaderResultado extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: [],
			icoLixo: false,
			params: {
				idArquivo: this.props.idArquivo,
				moduloEfd: this.props.moduloEfd,
				filtrobox: this.props.filtro,
				totalRegistros: this.props.totalReg
			},
			possuiValidacaoBasica: this.props.basicaHabilitado,
			possuiValidacaoInteligente: this.props.inteligenteHabilitado,
			botaoBasicoAtivo: this.props.basicaHabilitado,
			botaoInteligenteAtivo: this.props.inteligenteHabilitado,
			possuiValidacaoPerfil: this.props.perfilHabilitado,
			errosHabilitados: true,
			alertasHabiltiados: true,
			avisosHabilitados: true,
			tooltipOpen: false,
			tooltipOpenDFe: false,
			classChange : this.props.showDfe,
			popoverOpen: false,
			popoverOpenDFe: false,
			onLoading: false,
			mensagemAlerta: "",
			mostrarBotaoSim: false,
			textoBotaoConfirmacao: "",
			textoBotaoNegativo: "",
			dadosTabela: null,
			mostrarMensagem: 0
		};

		this.mensagemInicial = React.createRef();
		this.retornoAlerta = React.createRef();
		this.informacaoRetorno = React.createRef();
	}
	
	componentWillMount() {
		let urlApi =
			this.props.moduloEfd === 'Fiscal' || this.props.moduloEfd === 'SimplesNacional' ? Config.urls.API_URL_FISCAL
			: this.props.moduloEfd == 'ECF' ? Config.urls.API_URL_ECF
			: this.props.moduloEfd == 'ECD' ? Config.urls.API_URL_ECD
			: Config.urls.API_URL_CONT;
		let parametros = this.state.params.idArquivo;

		if (this.props.moduloEfd === 'Contribuicao') {
			parametros = parametros + '/' + idUsuario;
		}

		let url = urlApi + 'Validacao/RetornaDadosIdentificacaoArquivo/' + parametros


		HttpUtil.eco_GET(url, response => {
			this.setState({
				data: response.data
			});
			// this.props.cpfcnpj(this.state.data.strCnpjCpf, this.state.data.dtInicio, this.state.data.dtFim);
		},
			() => {
				console.log('Erro');
			});


	}

	goBack = props => {
		this.props.history.goBack();
	};

	changeClass = () => {
		this.setState({classChange: this.props.showDfe})
	}

	onHover = () => {
		this.setState({ icoLixo: true });
	};

	onLeave = () => {
		this.setState({ icoLixo: false });
	};

	onFiltroItensEmDivergenciaChanged = (
		errosHabilitados,
		alertasHabiltiados,
		avisosHabilitados
	) => {
		this.state.errosHabilitados = errosHabilitados;
		this.state.alertasHabiltiados = alertasHabiltiados;
		this.state.avisosHabilitados = avisosHabilitados;

		this.props.action(
			this.state.botaoBasicoAtivo,
			this.state.botaoInteligenteAtivo,
			this.state.possuiValidacaoPerfil,
			this.state.errosHabilitados,
			this.state.alertasHabiltiados,
			this.state.avisosHabilitados
		);
	};

	removerResultado = () => {
		return new Promise((resolve, reject) => {
			HttpUtil.eco_POST(
				Config.urls.API_URL_BASE + 'HistoricoArquivos/RemoverConsultaResultado',
				JSON.stringify({
					moduloEfd: this.state.params.moduloEfd,
					idArquivo: this.props.idArquivo
				}),
				response => {
					resolve({ resposta: response });
				},
				() => {
					console.log('Erro');
				}
			);
		});
	};

	prepararParaRemoverRegistro = () => {
		this.removerResultado().then(response => {
			this.goBack(this);
		});
	};

	alterarValidacaoBasica = checked => {
		this.state.botaoBasicoAtivo = checked;

		if (checked) {
			this.state.possuiValidacaoPerfil = false;
		}

		this.props.action(
			this.state.botaoBasicoAtivo,
			this.state.botaoInteligenteAtivo,
			this.state.possuiValidacaoPerfil,
			this.state.errosHabilitados,
			this.state.alertasHabiltiados,
			this.state.avisosHabilitados
		);

		this.forceUpdate();
	};

	alterarValidacaoInteligente = checked => {
		this.state.botaoInteligenteAtivo = checked;
		
		if (checked) {
			this.state.possuiValidacaoPerfil = false;
		}

			this.props.action(
			this.state.botaoBasicoAtivo,
			this.state.botaoInteligenteAtivo,
			this.state.possuiValidacaoPerfil,
			this.state.errosHabilitados,
			this.state.alertasHabiltiados,
			this.state.avisosHabilitados
		);

		this.forceUpdate();
	};

	alterarValidacaoPerfil = checked => {
		if (this.props.quantidadeErrosPerfil == 0)
			return;

		this.state.possuiValidacaoPerfil = checked;

		if (checked) {
			this.state.botaoInteligenteAtivo = false;
			this.state.botaoBasicoAtivo = false;
		}

		this.props.action(
			this.state.botaoBasicoAtivo,
			this.state.botaoInteligenteAtivo,
			this.state.possuiValidacaoPerfil,
			this.state.errosHabilitados,
			this.state.alertasHabiltiados,
			this.state.avisosHabilitados
		);

		this.forceUpdate();
	};

	// TOGGLE PRA LISTAGEM DO CRUZAMENTO DA DFE
	toggle() {
		this.setState({
			tooltipOpen: !this.state.tooltipOpen
		});
	}

	adicionarFiltroBasico = () => {
		if ((this.state.possuiValidacaoBasica && this.state.botaoBasicoAtivo) ||
			(this.props.bloquearFiltrosInativos == 'false' && this.state.botaoBasicoAtivo)) {
			return (
				<button className='ecobtn fat cinza ml-2 btBasica' onClick={() => this.alterarValidacaoBasica(false)} data-toggle="tooltip" data-placement="top" title="Validações efetuadas com base no Guia Prático e no PVA.">
					Básica
						{/* {this.props.errosBasica > 0 && <span>{this.props.errosBasica}</span>} */}
				</button>
			);
		}
		else if (this.props.bloquearFiltrosInativos == 'false' ||
			(this.state.possuiValidacaoBasica && !this.state.botaoBasicoAtivo)) {
			return (
				<button className='ecobtn fat vazado cinza ml-2 btBasica' onClick={() => this.alterarValidacaoBasica(true)} data-toggle="tooltip" data-placement="top" title="Validações efetuadas com base no Guia Prático e no PVA.">
					Básica
						{/* {this.props.errosBasica > 0 && <span>{this.props.errosBasica}</span>} */}
				</button>
			);
		}

		return '';
	};

	adicionarFiltroInteligente = () => {
		if (this.props.origem !== 'arquivos') {
			if (!this.state.possuiValidacaoInteligente) {
				return (
					<button className='ecobtn fat vazado azul-ceu ml-2 btInteligente' data-toggle="tooltip" data-placement="top" title="Validações adicionais que não existem no Guia Prático e PVA (Expertise Econet).">Inteligente</button>
				);
			}
			else {
				if ((this.state.possuiValidacaoInteligente && this.state.botaoInteligenteAtivo) ||
					(this.props.bloquearFiltrosInativos == 'false' && this.state.botaoInteligenteAtivo)) {
					return (
						<button className='ecobtn fat azul-ceu ml-2 btInteligente' onClick={() => this.alterarValidacaoInteligente(false)} data-toggle="tooltip" data-placement="top" title="Validações adicionais que não existem no Guia Prático e PVA (Expertise Econet).">
							Inteligente
								{/* {this.props.errosInteligente > 0 && <span>{this.props.errosInteligente}</span>} */}
						</button>
					);
				}
				else if (this.props.bloquearFiltrosInativos == 'false' ||
					(this.state.possuiValidacaoInteligente && !this.state.botaoInteligenteAtivo)) {
					return (
						<button className='ecobtn fat vazado azul-ceu ml-2 btInteligente' onClick={() => this.alterarValidacaoInteligente(true)} data-toggle="tooltip" data-placement="top" title="Validações adicionais que não existem no Guia Prático e PVA (Expertise Econet).">
							Inteligente
								{/* {this.props.errosInteligente > 0 && <span>{this.props.errosInteligente}</span>} */}
						</button>
					);
				}
			}
		}
		else {
			if ((this.state.possuiValidacaoInteligente && this.state.botaoInteligenteAtivo) ||
				(this.props.bloquearFiltrosInativos == 'false' && this.state.botaoInteligenteAtivo)) {
				return (
					<button className='ecobtn fat azul-ceu ml-2 btInteligente' onClick={() => this.alterarValidacaoInteligente(false)} data-toggle="tooltip" data-placement="top" title="Validações adicionais que não existem no Guia Prático e PVA (Expertise Econet).">
						Inteligente
							{/* {this.props.errosInteligente > 0 && <span>{this.props.errosInteligente}</span>} */}
					</button>
				);
			}
			else if (this.props.bloquearFiltrosInativos == 'false' ||
				(this.state.possuiValidacaoInteligente && !this.state.botaoInteligenteAtivo)) {
				return (
					<button className='ecobtn fat vazado azul-ceu ml-2 btInteligente' onClick={() => this.alterarValidacaoInteligente(true)} data-toggle="tooltip" data-placement="top" title="Validações adicionais que não existem no Guia Prático e PVA (Expertise Econet).">
						Inteligente
							{/* {this.props.errosInteligente > 0 && <span>{this.props.errosInteligente}</span>} */}
					</button>
				);
			}
		}

		return '';
	};

	adicionarFiltroPerfil = () => {
		if (this.state.params.moduloEfd != 'Fiscal' && this.state.params.moduloEfd != 'SimplesNacional')
			return <div></div>;

		if (this.state.possuiValidacaoPerfil) {
			return (
				<button
					className='ecobtn fat cinza float-right'
					onClick={() => this.alterarValidacaoPerfil(false)}
				>
					Perfil {this.state.data.strPerfil} {this.props.quantidadeErrosPerfil > 0 ? `- ${this.props.quantidadeErrosPerfil}` : ''}
				</button>
			);
		} else if (
			this.props.bloquearFiltrosInativos == 'false' ||
			this.props.quantidadeErrosPerfil > 0
		) {
			return (
				<button
					className='ecobtn fat vazado cinza float-right'
					onClick={() => this.alterarValidacaoPerfil(true)}
				>
					Perfil {this.state.data.strPerfil} {this.props.quantidadeErrosPerfil > 0 ? `- ${this.props.quantidadeErrosPerfil}` : ''}
				</button>
			);
		}

		return '';
	};

	monstrarModulo = () => {
		if (this.state.params.moduloEfd === 'Contribuicao') {
			return (
				<div>
					<button className='ecobtn fit baby-blue'>C</button>
					<span>Contribuições</span>
					<time>
						{Moment(this.state.data.dtFim, 'D/M/YYYY').format('MMM - Y')}
					</time>
				</div>
			);
		}
		if (this.state.params.moduloEfd === 'ECF') {
			return (
				<div>
					<button className='ecobtn fit azul-marinho'>E</button>
					<span>ECF - {Moment(this.state.data.dtFim, 'D/M/YYYY').format('Y')}</span>
				</div>
			);
		}
		if (this.state.params.moduloEfd === 'ECD') {
			return (
				<div>
					<button className='ecobtn fit azul-marinho'>ECD</button>
					<span>ECD - {Moment(this.state.data.dtFim, 'D/M/YYYY').format('Y')}</span>
				</div>
			);
		}
		if (this.state.params.moduloEfd === 'Fiscal') {
			return (
				<div>
					<button className='ecobtn fit baby-blue'>F</button>
					<span>Fiscal</span>
					<time>
						{Moment(this.state.data.dtFim, 'D/M/YYYY').format('MMM - Y')}
					</time>
				</div>
			);
		}
		if (this.state.params.moduloEfd === 'SimplesNacional') {
			return (
				<div>
					<button className='ecobtn fit azul-marinho'>SN</button>
					<span>Simples Nacional</span>
					<time>
						{Moment(this.state.data.dtFim, 'D/M/YYYY').format('MMM - Y')}
					</time>
				</div>
			);
		}
		return null;
	};

	monstrarRelatorio = () => {
		let pageResulErros = window.location.pathname.indexOf('/resultadoErros');

		if (pageResulErros != 0) {
			return (
				<div
					className='btRelatorios'
					onClick={e => {
						e.preventDefault();
					}}
				>
					<OpcoesDownloadItem
						idArquivo={this.props.idArquivo}
						moduloEfd={this.props.moduloEfd}
						tipoValidacao={
							this.state.possuiValidacaoBasica &&
								this.state.possuiValidacaoInteligente
								? 'basica,inteligente'
								: this.state.possuiValidacaoBasica
									? 'basica'
									: 'inteligente'
						}
						status={this.props.status}
						origem={this.props.origem}
						existeRelatorio={this.state.existeRelatorio}
					/>
					<span>Relatórios</span>
				</div>
			);
		}
	};

	//EXPORTAR EXCEL - Inicio
	downloadFile(file, filename) {
		const a = document.createElement('a')
		a.href = URL.createObjectURL(file)
		a.download = filename
		a.click()
		setTimeout(() => {
			URL.revokeObjectURL(a.href)
		}, 500)
	}

	converterTxtEmXlsx = () => {
		let url = "";
		let pageResulErros = window.location.pathname.indexOf('/resultadoErros');

		url = `${Config.urls.API_URL_BASE}Exportacao/ExportarParaXlsx/${this.props.moduloEfd}/${this.state.params.idArquivo}/${idUsuario}`
		
		let filename = `ImportarArquivo_${ this.state.params.idArquivo }_${this.props.moduloEfd}.xlsx`;
		
		const downloadExcel = async () => {
			this.setState({ onLoading: true });

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				},
			});

			if (response.ok) {
				const blob = await response.blob();
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = filename; 
				document.body.appendChild(a);
				a.click();
				a.remove();
				window.URL.revokeObjectURL(url);
			} else {
				this.setState({ onLoading: false });
				console.error('Erro ao baixar o arquivo:', response.statusText);
			}

			this.setState({ onLoading: false });
		};
		

		if (pageResulErros != 0) {
			return (

				<button
					disabled={this.state.onLoading}
					className='btConverterTxtEmXlsx'
					onClick={!this.state.onLoading && downloadExcel}
				>
					{!this.state.onLoading && <i id={'buttonConverterTxtEmXlsx-' + this.props.idArquivo} className={"ecoico ecoico-arquivos"} ></i>}
					{this.state.onLoading && <span class="loading"></span>}
					<span>Exportar xlsx</span>
				</button>
			);
		}
	};
	//EXPORTAR EXCEL - Termino

	mostrarBotaoDFe = () => {
		return (
			<div 
				className='btDFe' 
				title="Cruzar informações com o EcoDFe" 
				onClick={e => {
					e.preventDefault();
				}}
			>
				<div className="">
					<i
						class='ecoico ecoico-comparar'
						onClick={this.toggleDFe}
						id='cruzarDFeId'
					></i>
					<Popover 
						placement="bottom" 
						isOpen={this.state.popoverOpenDFe} 
						toggle={this.toggleDFe}
						target='cruzarDFeId'
					>
						<PopoverBody>
						<div className='boxDFe'>
							<div>
								<p>
								Antes de cruzar os dados da escrituração fiscal com o EcoDFe, 
								favor atualizar a sincronização dos documentos no EcoDFe.
								</p>
							</div>
							<div className='buttonsDFe'>
								<button 
									className='ecobtn fit azul-marinho'
									onClick={this.buscarDFe}
								>
									Cruzar Dados
								</button>
								<button 
									className='ecobtn fit vazado azul-ceu'
									onClick={this.toggleDFe}
								>
									Fechar
								</button>
							</div>
						</div>
						</PopoverBody>
					</Popover>
				</div>
				<span>DFe</span>
			</div>
		)
	}

	//ICMS APURAÇÃO - Inicio
	primeiraModalIcmsApuracao = () => {
		this.setState({
			mostrarMensagem: 1
		});

		this.forceUpdate();

		this.mensagemInicial.current.alterarVisibilidadeModal();
	}

	verificarArquivoIcmsApuracao = () => {
		new Promise((resolve, reject) => {
			let url = `${Config.urls.API_URL_FISCAL}Validacao/IcmsApuracao/Verificacao/${this.state.params.idArquivo}/${idUsuario}`;
			HttpUtil.eco_GET(url, (response) => {
				if (!response.data.sucesso) {
					this.state.mensagemAlerta = response.data.mensagem;
					this.state.mostrarBotaoSim = false;
					this.state.mostrarMensagem = 2;
					this.state.textoBotaoConfirmacao = "";
					this.state.textoBotaoNegativo = "Fechar";
				}
				else {
					this.state.mostrarBotaoSim = true;
					this.state.mostrarMensagem = 3;
					this.state.textoBotaoConfirmacao = "Sim";
				}

				this.retornoValidacaoIcmsApuracao();

			}, () => { console.log("Error"); });
		}).then(() => {
			this.props.action();
		});
	}

	retornoValidacaoIcmsApuracao = () => {
		this.setState({
			mensagemAlerta: this.state.mensagemAlerta,
			mostrarMensagem: this.state.mostrarMensagem,
			mostrarBotaoSim: this.state.mostrarBotaoSim,
			textoBotaoConfirmacao: this.state.textoBotaoConfirmacao,
			textoBotaoNegativo: this.state.textoBotaoNegativo
		});

		this.retornoAlerta.current.alterarVisibilidadeModal();
	}

	// executarIcmsApuracao = () => {
	// 	new Promise((resolve, reject) => {
	// 		let url = Config.urls.API_URL_FISCAL + 'Validacao/IcmsApuracao';

	// 		let data = new FormData();
	// 		data.append('idArquivo', this.state.params.idArquivo);
	// 		data.append('idUsuario', idUsuario);

	// 		HttpUtil.eco_POST(url, data, response => {
	// 			if (!response.data.sucesso) {
	// 				this.state.mensagemAlerta = response.data.mensagem;
	// 				this.state.mostrarBotaoSim = false;
	// 				this.state.mostrarMensagem = 0;
	// 				this.state.textoBotaoConfirmacao = "";
	// 				this.state.textoBotaoNegativo = "Fechar";

	// 				this.retornoValidacaoIcmsApuracao();
	// 			}
	// 			else {
	// 				this.state.dadosTabela = response.data.lstInformacoesDasGuiasIcmsApuracao;
	// 				this.state.mostrarBotaoSim = true;
	// 				this.state.mostrarMensagem = 4;
	// 				this.state.textoBotaoConfirmacao = "Ir Para GNRE";
	// 				this.state.textoBotaoNegativo = "Fechar";
					
	// 				this.alertaDeConfirmacaoIcmsApuracao();
	// 			}
	// 		}, () => { console.log("Error"); });
	// 	}).then(() => {
	// 		this.props.action();
	// 	});
	// }

	alertaDeConfirmacaoIcmsApuracao = () => {
		this.setState({
			mensagemAlerta: this.state.mensagemAlerta,
			mostrarMensagem: this.state.mostrarMensagem,
			mostrarBotaoSim: this.state.mostrarBotaoSim,
			dadosTabela: this.state.dadosTabela,
			textoBotaoConfirmacao: this.state.textoBotaoConfirmacao,
			textoBotaoNegativo: this.state.textoBotaoNegativo
		});

		this.informacaoRetorno.current.alterarVisibilidadeModal();
	}

	redirecionarParaGNRE = () => {
		window.location.href = "https://gnre.econeteditora.com.br/";
	}
	//ICMS APURAÇÃO  - Termino

	FiltrosBox() {
		if (this.state.params.filtrobox) {
			if (this.props.moduloEfd == 'Fiscal') {
				return (
					<div className='btsValidacao'>
						<span>Validações ativas: </span>
						{this.adicionarFiltroBasico()}
						{this.adicionarFiltroInteligente()}
						{this.adicionarFiltroPerfil()}
					</div>
				);
			} else if (this.props.moduloEfd == 'SimplesNacional') {
				return (
					<div className='btsValidacao'>
						<span>Validações ativas: </span>
						{this.adicionarFiltroBasico()}
					</div>
				);
			} else if (this.props.moduloEfd == 'ECF'){
				return (
					<div className='btsValidacao'>
						<span>Validações ativas: </span>
						{this.adicionarFiltroBasico()}
						{this.adicionarFiltroInteligente()}
						{this.adicionarFiltroPerfil()}
					</div>
				);
			} else {
				return (
					<div className='btsValidacao'>
						<span>Validações ativas: </span>
						{this.adicionarFiltroBasico()}
						{this.adicionarFiltroInteligente()}
						{this.props.moduloEfd != 'ECD' ? this.adicionarFiltroPerfil() : ""}
					</div>
				);
			}
		} else {
			return (
				<p>
					Corrija os erros estruturais encontrados e envie o arquivo novamente
				</p>
			);
		}
	}

	formatarDocumento = () => {
		if (this.state.data.length !== 0 && this.state.data.strCnpjCpf) {
			if (this.state.data.strCnpjCpf.length === 11) {
				return 'CPF: ' + this.state.data.strCnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '\$1.\$2.\$3\-\$4');
			}
			else if (this.state.data.strCnpjCpf.length > 11) {
				return 'CNPJ: ' + this.state.data.strCnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '\$1.\$2.\$3\/\$4\-\$5');
			}
		}
		else {
			return "Deu erro!";
		}
	}

	buscarDFe = () => {
		// this.props.changeDFe(this.state.data.strCnpjCpf, this.state.data.dtInicio, this.state.data.dtFim);
		// this.toggleDFe();
	}

	// TOGGLE DO BOTÃO DE BUSCA DO CRUZAMENTO DA DFE
	toggleDFe = () => {
		this.setState({
			popoverOpenDFe: !this.state.popoverOpenDFe
		});
	}

	sendDFe = () => {
		this.props.setShowAbas("DFE")
		this.props.setPropsDFe(this.state.data.strCnpjCpf, this.state.data.dtInicio, this.state.data.dtFim);
	}

	sendResultado = () => {
		this.props.setShowAbas("RESULTADO")
	}

	sendIcms = () => {
		this.props.setShowAbas("ICMS")
		this.props.setPropsICMS(this.state.params.idArquivo, idUsuario)
	}

	render() {
		return (
			<Container>
				<Row className='modulos'>
					<Col xs={12} md={this.props.moduloEfd == 'SimplesNacional' ? 3 : 1} className='tpModulo'>
						{this.monstrarModulo()}
					</Col>
					<Col xs={12} md={this.props.moduloEfd == 'SimplesNacional' ? 6 : 6} className='empDados'>
						<Row className='empDados-nome'>
							<Col>{this.state.data.strNomeEmpresa}</Col>
						</Row>
						<Row className='empDados-cnpj'>
							<Col>{this.formatarDocumento()}</Col>
						</Row>
					</Col>

					<Col xs={12}  md={2}>
						{/* // BT CRUZAR DFE // */}
						{
							// !this.props.isFiscal
							// ||
							// this.mostrarBotaoDFe()
						}
						
						{/* // BT ICMS POR APURACAO // */}
						{
							// this.props.isFiscal &&
							// <div>
							// 	<button className='ecobtn fit azul-marinho' onClick={this.primeiraModalIcmsApuracao.bind(this)}>
							// 		<span>Icms Por Apuracao Modal</span>
							// 	</button>
							// 	<ModalAlerta ref={this.mensagemInicial} mostrarBotaoSim={true} textoBotaoConfirmacao={"Continuar"} textoBotaoNegativo={"Canelar"}
							// 		mostrarMensagem={1} action={this.verificarArquivoIcmsApuracao.bind(this)} ></ModalAlerta>
							// 	<ModalAlerta ref={this.retornoAlerta} mostrarBotaoSim={this.state.mostrarBotaoSim} textoBotaoConfirmacao={this.state.textoBotaoConfirmacao}
							// 		mostrarMensagem={this.state.mostrarMensagem} textoBotaoNegativo={this.state.textoBotaoNegativo}
							// 		mensagemAlerta={this.state.mensagemAlerta } action={this.executarIcmsApuracao.bind(this)}></ModalAlerta>
							// 	<ModalAlerta ref={this.informacaoRetorno} mostrarBotaoSim={this.state.mostrarBotaoSim} textoBotaoConfirmacao={this.state.textoBotaoConfirmacao}
							// 		textoBotaoNegativo={this.state.textoBotaoNegativo} mostrarMensagem={this.state.mostrarMensagem}
							// 		mensagemAlerta={this.state.mensagemAlerta} dadosTabela={this.state.dadosTabela}
							// 		action={this.redirecionarParaGNRE.bind(this)}></ModalAlerta>
							// </div>
						}
					</Col>

					<Col xs={12} md={3} className='botoes'>

						{/* // BT EXCLUIR // */}
						{(!isSimulacao && !isPro && this.props.origem != 'arquivos') &&
							<div className='btExcluir'>
								<RemoverResultadoItem
									className='btExcluir'
									idArquivo={this.props.idArquivo}
									moduloEfd={this.state.params.moduloEfd}
									action={this.goBack}
									onLoading={this.props.onLoading}
								/>
								<span>Excluir</span>
							</div>
						}
						{/* // BT DOWNLOAD // */}
						{!this.state.filtrobox && (
							this.monstrarRelatorio()
						)}

						{/* // EXPORTAR XLSX - Inicio // */}
						 {/* || this.props.moduloEfd === 'ECD' */}
						{(this.props.isFiscal || this.props.moduloEfd === 'Contribuicao' || this.props.moduloEfd === 'ECF' ) && this.props.origem === 'arquivos' && !this.state.filtrobox && (
							this.converterTxtEmXlsx()
						)}
						{/* // EXPORTAR XLSX - Termino // */}

						{/* // BT VOLTAR // */}
						<div className='btVoltar'>
							<i
								class='ecoico ecoico-voltar'
								onClick={this.goBack.bind(this)}
							/>
							<span>Voltar</span>
						</div>
					</Col>
				</Row>

				{/* MSG OU FILTROS */}
				<Row className='errosFiltros'>
					<Col 
						md={2} 
						className={this.props.showAbas == 'RESULTADO' ? 'errosFiltros selectedTab' : 'unselectedTab'}
						onClick={this.sendResultado}
					>
						<FiltroItensEmDivergencia
							totalReg={this.props.totalReg}
							idArquivo={this.props.idArquivo}
							quatidadeErros={this.props.quatidadeErros}
							quatidadeAlertas={this.props.quatidadeAlertas}
							quatidadeAvisos={this.props.quatidadeAvisos}
							action={this.onFiltroItensEmDivergenciaChanged}
							exibirFiltro={this.state.params.filtrobox}
							onClick={this.changeClass}
						/>
					</Col>
					{/* {
						this.props.showLoadingDFe && !this.props.showDFe
						?
						<Col 
							md={2} 
							className={this.props.showAbas == 'DFE' ? 'selectedTab' : 'unselectedTab'}
						>
							<div className="opcoes-filtro">
								<div>
									<b>Carregando...</b>
								</div>
							</div>
						</Col>
						:
						null
					} */}
					{
						// this.props.showDFe && !this.props.showLoadingDFe
						this.props.isFiscal
						?
						<Col 
							md={2} 
							className={this.props.showAbas == 'ICMS' ? 'errosFiltros selectedTab' : 'unselectedTab'}
							onClick={this.sendIcms}
						>
							<div 
								className=""
								onClick={this.changeClass}
							>
								<div className="centerText">
									<b>Gerar GNRE outra UF</b>
								</div>
							</div>
						</Col>
						:
						null
					}
										{
						// this.props.showDFe && !this.props.showLoadingDFe
						this.props.isFiscal
						?
						<Col 
							md={2} 
							className={this.props.showAbas == "DFE" ? 'errosFiltros selectedTab' : 'unselectedTab'}
							onClick={this.sendDFe}
						>
							<div 
								className="flexCustom"
								onClick={this.changeClass}
							>
								<div>
									<b>Cruzar dados EcoDFe</b>
								</div>
							</div>
						</Col>
						:
						null
					}
				</Row>
				{this.props.showAbas == 'RESULTADO' ? (
					<Row className="bottomBar">
						<Col>
							<div className='validacoes'>
								{this.FiltrosBox()}
							</div>
						</Col>
					</Row>
				) : null}
			</Container>
		);
	}
}

//export default HeaderResultado;
export default withRouter(HeaderResultado);



// WEBPACK FOOTER //
// ./src/Componente/Resultado/HeaderResultado.jsx